<template>
    <c-modal class="md:max-w-[800px]" title="TIG létrehozása" v-bind:open="open" v-on:closeModal="closeDestination">
        <template v-slot:body>
            <div class="mb-6">
                <label class="block font-semibold mb-2 text-sm text-slate-700">Partner kiválasztása</label>
                <c-control-autocomplete class="w-full"
                                        icon="briefcase"
                                        label-field="name"
                                        name="partner-select"
                                        v-bind:placeholder="__('Search by partner name or tax ID')"
                                        v-bind:source-get="partnerGet"
                                        v-bind:source-search="partnerSearch"
                                        v-bind:sublabel-field="(data) => data.postcode + ' ' + data.city + ' (' + data.country + '), ' + data.address_line_1"
                                        v-model="filtersPartner"
                />
            </div>

            <template v-if="filtersPartner">
                <div class="mb-10 flex flex-col md:flex-row md:items-center">
                    <c-control-text
                        class="grow-0 mb-4 md:max-w-[300px] md:mb-0 md:mr-4"
                        icon="search"
                        name="search-worksheets"
                        placeholder="Munkalap keresés"
                        v-model="s"
                        v-on:keyup="search"
                    />

                    <div class="flex items-center justify-between lg:w-auto w-full">
                        <div class="relative">
                            <a class="cursor-pointer duration-500 flex hover:decoration-dotted hover:underline items-center p-1 rounded text-sm transition-all"
                               v-bind:class="{ 'bg-highlight text-white' : Object.keys(filters).length }"
                               v-on:click="openFilters = true"
                            >
                                <c-icon class="h-5 mr-2 stroke-slate-800 w-5"
                                        icon="filter"
                                        v-bind:class="{ '!stroke-white' : Object.keys(filters).length }"
                                />
                                {{ __('Filter results') }}
                                <span class="bg-white flex font-bold h-4 items-center justify-center ml-1 rounded-full text-center text-highlight text-xs w-4"
                                      v-if="Object.keys(filters).length"
                                >
                                    {{ Object.keys(filters).length }}
                                </span>
                            </a>
                            <div class="absolute bg-white border border-slate-200 hidden md:w-[500px] mt-1 rounded shadow-lg w-[calc(100vw-0.5rem)] z-30"
                                 v-bind:class="{ '!block' : openFilters }"
                                 v-on-click-outside="closeFilters"
                            >
                                <div class="flex">
                                    <nav class="bg-slate-50 border-r border-slate-200 flex flex-col shrink-0 text-sm">
                                        <a class="border-b border-slate-200 cursor-pointer px-2 py-4"
                                           v-bind:class="{ 'after:absolute after:border after:border-[7px] after:border-transparent after:border-l-white after:content-[\'\'] after:h-0 after:left-full after:top-1/2 after:-translate-y-1/2 after:w-0 before:absolute before:border before:border-[8px] before:border-transparent before:border-l-slate-200 before:content-[\'\'] before:h-0 before:left-full before:top-1/2 before:-translate-y-1/2 before:w-0 !bg-white relative' : openFilter === 'worksheet_id' }"
                                           v-on:click="openFilter = 'worksheet_id'"
                                        >
                                            {{ __('Worksheet #') }}
                                        </a>
                                        <a class="border-b border-slate-200 cursor-pointer px-2 py-4"
                                           v-bind:class="{ 'after:absolute after:border after:border-[7px] after:border-transparent after:border-l-white after:content-[\'\'] after:h-0 after:left-full after:top-1/2 after:-translate-y-1/2 after:w-0 before:absolute before:border before:border-[8px] before:border-transparent before:border-l-slate-200 before:content-[\'\'] before:h-0 before:left-full before:top-1/2 before:-translate-y-1/2 before:w-0 !bg-white relative' : openFilter === 'worksheet_created_at' }"
                                           v-on:click="openFilter = 'worksheet_created_at'"
                                        >
                                            {{ __('Worksheet created at') }}
                                        </a>
                                        <a class="border-b border-slate-200 cursor-pointer px-2 py-4"
                                           v-bind:class="{ 'after:absolute after:border after:border-[7px] after:border-transparent after:border-l-white after:content-[\'\'] after:h-0 after:left-full after:top-1/2 after:-translate-y-1/2 after:w-0 before:absolute before:border before:border-[8px] before:border-transparent before:border-l-slate-200 before:content-[\'\'] before:h-0 before:left-full before:top-1/2 before:-translate-y-1/2 before:w-0 !bg-white relative' : openFilter === 'worksheet_signed_at' }"
                                           v-on:click="openFilter = 'worksheet_signed_at'"
                                        >
                                            {{ __('Worksheet signed at') }}
                                        </a>
                                        <a class="border-b border-slate-200 cursor-pointer px-2 py-4"
                                           v-bind:class="{ '!bg-white relative' : openFilter === 'assignee' }"
                                           v-on:click="openFilter = 'assignee'"
                                        >
                                            {{ __('Primary assignee') }}
                                        </a>
                                    </nav>
                                    <div class="hidden px-5 py-2 w-full"
                                         v-bind:class="{ '!flex' : openFilter === 'worksheet_id' }"
                                    >
                                        <c-control-text class="w-full"
                                                        name="filters.worksheet_id"
                                                        v-bind:placeholder="__('Search')"
                                                        v-model="filtersWorksheetId"
                                        />
                                    </div>
                                    <div class="flex-col grow hidden px-5 py-2"
                                         v-bind:class="{ '!flex' : openFilter === 'worksheet_created_at' }"
                                    >
                                        <div class="mb-5">
                                            <c-control-radio grid="md:grid-cols-2"
                                                             name="filters.worksheet_created_at.speeddial"
                                                             v-bind:options="filtersSpeedial.options"
                                                             v-model="filtersSpeedial.worksheet_created_at"
                                                             v-on:change="updateDateFilter('worksheet_created_at')"
                                            />
                                        </div>
                                        <c-control-date icon="calendar"
                                                        icon-position="right"
                                                        name="filters.worksheet_created_at"
                                                        multi-calendars
                                                        range
                                                        v-bind:formats="{ input: localizationStore.dateFormat }"
                                                        v-bind:time-config="{ enableTimePicker: false }"
                                                        v-model="filters.worksheet_created_at"
                                        />
                                    </div>
                                    <div class="flex-col grow hidden px-5 py-2"
                                         v-bind:class="{ '!flex' : openFilter === 'worksheet_signed_at' }"
                                    >
                                        <div class="mb-5">
                                            <c-control-radio grid="md:grid-cols-2"
                                                             name="filters.worksheet_signed_at.speeddial"
                                                             v-bind:options="filtersSpeedial.options"
                                                             v-model="filtersSpeedial.worksheet_signed_at"
                                                             v-on:change="updateDateFilter('worksheet_signed_at')"
                                            />
                                        </div>
                                        <c-control-date icon="calendar"
                                                        icon-position="right"
                                                        name="filters.worksheet_signed_at"
                                                        multi-calendars
                                                        range
                                                        v-bind:formats="{ input: localizationStore.dateFormat }"
                                                        v-bind:time-config="{ enableTimePicker: false }"
                                                        v-model="filters.worksheet_signed_at"
                                        />
                                    </div>
                                    <div class="hidden px-5 py-2 w-full"
                                         v-bind:class="{ '!flex' : openFilter === 'assignee' }"
                                    >
                                        <c-control-autocomplete avatar-field="avatar"
                                                                class="w-full"
                                                                label-field="name"
                                                                name="filters.assignee"
                                                                v-bind:placeholder="__('Search by employee name')"
                                                                v-bind:source-get="employeeGet"
                                                                v-bind:source-search="employeeSearch"
                                                                v-model="filtersEmployee"
                                        />
                                    </div>
                                </div>
                                <div class="border-t border-slate-200 flex justify-end p-2">
                                    <c-button class="hover:decoration-dotted hover:underline mr-2 p-1.5 text-error" v-on:click="resetFilters">
                                        {{ __('Reset filters') }}
                                    </c-button>
                                    <c-button class="bg-highlight p-1.5 shrink-0 text-white" v-on:click="filter">
                                        {{ __('Apply filters') }}
                                    </c-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-2 flex items-center pl-2"
                     v-if="tableData.items.length > 0"
                >
                    <input
                        class="mr-2 h-4 w-4 cursor-pointer rounded border-slate-300 text-highlight focus:ring-highlight"
                        type="checkbox"
                        id="select-all-worksheets"
                        v-bind:checked="allWorksheetsSelected"
                        v-on:change="toggleSelectAllWorksheets"
                    />
                    <label class="cursor-pointer text-xs" for="select-all-worksheets">
                        Összes munkalap kiválasztása
                    </label>
                </div>

                <c-data-table
                    class="mt-2"
                    responsive-breakpoint="lg"
                    v-bind:data="tableData"
                    v-if="tableData.items.length > 0"
                >
                    <template v-slot:item.selected="{ item }">
                        <input
                            class="h-4 w-4 cursor-pointer rounded border-slate-300 text-highlight focus:ring-highlight"
                            type="checkbox"
                            v-bind:checked="isWorksheetSelected(item.values.id)"
                            v-on:change="toggleWorksheetSelection(item.values)"
                        />
                    </template>
                    <template v-slot:item.oid="{ item }">
                        <span class="text-slate-500 text-xs">#{{ item.values.worksheet.oid }}</span>
                    </template>
                    <template v-slot:item.title="{ item }">
                        <span class="block">{{ item.values.title }}</span>
                    </template>
                    <template v-slot:item.partner="{ item }">
                        {{ item.values.site.partner.name }}
                    </template>
                    <template v-slot:item.signed_at="{ item }">
                        <span v-if="item.values.worksheet.signed_at">
                            {{
                                DateTime.fromISO(
                                    item.values.worksheet.signed_at,
                                    { locale : localizationStore.locale }
                                ).toFormat(localizationStore.dateFormat)
                            }}
                        </span>
                        <span v-else>-</span>
                    </template>
                </c-data-table>

                <c-pagination class="my-10"
                              v-bind:current-page="pagesCurrent"
                              v-bind:pages="pagesTotal"
                              v-if="tableData.items.length > 0"
                              v-on:updatePage="updatePage"
                />

                <div
                    class="flex flex-col items-center justify-center text-center"
                    v-else
                >
                    <img
                        class="mb-5"
                        src="/img/empty-state.png"
                        srcset="/img/empty-state.png 2x"
                        v-bind:alt="__('There are no results available.')"
                    />
                    <div class="flex flex-col items-center justify-center text-center">
                        <span class="font-semibold mb-2 text-center text-lg text-slate-500">
                            {{ __('There are no results available.') }}
                        </span>
                    </div>
                </div>
            </template>

            <div
                class="flex flex-col items-center justify-center text-center"
                v-else
            >
                <img
                    class="mb-5"
                    src="/img/empty-state.png"
                    srcset="/img/empty-state.png 2x"
                    v-bind:alt="__('There are no results available.')"
                />
                <div class="flex flex-col items-center justify-center text-center">
                    <span class="font-semibold mb-2 text-center text-lg text-slate-500">
                        Válasszon partnert a munkalapok megjelenítéséhez
                    </span>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <div class="flex justify-end w-full">
                <c-button
                    class="bg-slate-100 mr-2 text-slate-800"
                    v-on:click="closeDestination"
                >
                    {{ __('Cancel') }}
                </c-button>
                <c-button
                    class="bg-highlight text-white"
                    v-bind:disabled="selectedWorksheets.length === 0"
                    v-on:click="submit"
                >
                    Létrehozás
                </c-button>
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
    import { inject, ref, computed, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { vOnClickOutside } from '@vueuse/components';
    import debounce from 'debounce';
    import { DateTime } from 'luxon';
    import {
        CButton,
        CControlAutocomplete,
        CControlDate,
        CControlRadio,
        CControlText,
        CDataTable,
        CIcon,
        CModal,
        CPagination,
    } from '@teamfurther/cinderblock';
    import EmployeeRepository from '../../../../repositories/EmployeeRepository';
    import PartnerRepository from '../../../../repositories/PartnerRepository';
    import TicketRepository from '../../../../repositories/TicketRepository';
    import { useLocalizationStore } from '../../../../stores/localization';
    import { useRequestStore } from '../../../../stores/request';

    const __ = inject('__');

    const allWorksheetsSelected = computed(() => {
        if ((tableData.value as any).items.length === 0) {
            return false;
        }

        const allIds = ((tableData.value as any).items as any[]).map((item) => item.values.id);

        return allIds.every((id) => selectedWorksheets.value.some((worksheet) => worksheet.id === id));
    });

    const closeFilters = [
        (e) => {
            if (!e.target.className?.toString().startsWith('dp__')) {
                openFilters.value = false;
            }
        },
    ];

    const employeeRepository = EmployeeRepository.getInstance();
    const filters = ref<any>({});
    const filtersEmployee = ref<any>();
    const filtersPartner = ref<any>();
    const filtersSpeedial = ref<any>({
        options: [
            { label : __('Today'), value : 'today' },
            { label : __('Yesterday'), value : 'yesterday' },
            { label : __('This week'), value : 'this_week' },
            { label : __('Last week'), value : 'last_week' },
            { label : __('This month'), value : 'this_month' },
            { label : __('Last month'), value : 'last_month' },
            { label : __('This year'), value : 'this_year' },
            { label : __('Last year'), value : 'last_year' },
            { label : __('Anytime'), value : 'anytime' },
        ],
        worksheet_created_at : 'anytime',
        worksheet_signed_at : 'anytime',
    });
    const filtersWorksheetId = ref<string>();
    const localizationStore = useLocalizationStore();
    const open = ref<boolean>(true);
    const openFilter = ref<string>('worksheet_id');
    const openFilters = ref<boolean>(false);
    const pagesCurrent = ref(1);
    const pagesTotal = ref(1);
    const partnerRepository = PartnerRepository.getInstance();
    const requestStore = useRequestStore();
    const router = useRouter();
    const selectedWorksheets = ref<any[]>([]);
    const s = ref<string>('');

    const search = debounce(async () => {
        if (s.value) {
            filters.value.search = s.value;
        } else {
            delete filters.value.search;
        }

        pagesCurrent.value = 1;
        await getResults();
    }, 500);
    
    const sort = ref<string>('');

    const tableData = ref<any>({
        columnNames: {
            selected: '',
            oid: __('Worksheet #'),
            title: __('Ticket title'),
            partner: __('Partner'),
            signed_at: __('Signed at'),
        },
        defaultSort: '-signed_at',
        items: [],
        sortableColumns: [],
    });

    const ticketRepository = TicketRepository.getInstance();

    function closeDestination() {
        open.value = false;

        if (!window.history.state.back) {
            router.push({ name : 'electronholding.reports.tig' });
        } else {
            router.go(-1);
        }
    }

    async function employeeGet(employeeId) {
        if (!employeeId.value) {
            return null;
        }

        return await employeeRepository.show(employeeId.value.id);
    }

    async function employeeSearch(val) {
        return await employeeRepository.index({
            filters : {
                inactive: 'with',
                search: val,
            },
        });
    }

    async function getResults() {
        if (filtersEmployee.value) {
            filters.value.assignee_id = filtersEmployee.value.id;
        } else {
            delete filters.value.assignee_id;
        }

        if (filtersWorksheetId.value) {
            filters.value.worksheet_oid = filtersWorksheetId.value;
        } else {
            delete filters.value.worksheet_oid;
        }

        const result = await ticketRepository.index({
            filters: {
                ...filters.value,
                ...{
                    is_closed : 1,
                    partner_id : filtersPartner.value?.id,
                },
            },
            include: ['site', 'site.partner', 'worksheet'],
            page: pagesCurrent.value,
            paginate: 1,
            sort: sort.value,
        });

        pagesCurrent.value = result.current_page;
        pagesTotal.value = result.last_page;

        tableData.value.items = result.data.map((worksheet) => {
            return { values : worksheet };
        });
    }

    async function filter() {
        await getResults();

        openFilters.value = false;
    }

    function isWorksheetSelected(id: string) {
        return selectedWorksheets.value.some((worksheet) => worksheet.id === id);
    }

    async function partnerGet(partnerId) {
        if (!partnerId.value) {
            return null;
        }

        return await partnerRepository.show(partnerId.value.id);
    }

    async function partnerSearch(val) {
        return await partnerRepository.index({
            filters : {
                search: val,
            },
        });
    }

    async function resetFilters() {
        filters.value = {};
        filtersEmployee.value = null;
        filtersSpeedial.value.worksheet_created_at = 'anytime';
        filtersSpeedial.value.worksheet_signed_at = 'anytime';
        filtersWorksheetId.value = null;
        s.value = '';

        openFilters.value = false;

        pagesCurrent.value = 1;
        await getResults();
    }

    async function submit() {
        const payload = {
            tz: DateTime.now().zoneName,
            worksheet_ids: selectedWorksheets.value.map((w) => w.worksheet.id),
        };

        try {
            await requestStore.post('t/electronholding/tig', payload);

            requestStore.message = 'TIG sikeresen létrehozva';
            requestStore.status = 200;
            requestStore.title = (__ as any)('Success');
            
            closeDestination();
        } catch (error) {
            console.error('Failed to generate TIG:', error);
        }
    }

    function toggleSelectAllWorksheets() {
        if (allWorksheetsSelected.value) {
            selectedWorksheets.value = [];
        } else {
            const all = ((tableData.value as any).items as any[]).map((item) => item.values);
            selectedWorksheets.value = all;
        }
    }

    function toggleWorksheetSelection(worksheet: any) {
        if (isWorksheetSelected(worksheet.id)) {
            selectedWorksheets.value = selectedWorksheets.value.filter((w) => w.id !== worksheet.id);
        } else {
            selectedWorksheets.value.push(worksheet);
        }
    }

    function updateDateFilter(field : string) {
        const dates = (() => {
            switch (filtersSpeedial.value[field]) {
                case 'today':
                    return [
                        DateTime.now(),
                        DateTime.now(),
                    ];
                case 'yesterday':
                    return [
                        DateTime.now().minus({ days: 1 }),
                        DateTime.now().minus({ days: 1 }),
                    ];
                case 'this_week':
                    return [
                        DateTime.now().startOf('week'),
                        DateTime.now(),
                    ];
                case 'last_week':
                    return [
                        DateTime.now().startOf('week').minus({ days: 7 }),
                        DateTime.now().startOf('week').minus({ days: 1 }),
                    ];
                case 'this_month':
                    return [
                        DateTime.now().startOf('month'),
                        DateTime.now(),
                    ];
                case 'last_month':
                    return [
                        DateTime.now().startOf('month').minus({ month: 1 }),
                        DateTime.now().startOf('month').minus({ days: 1 }),
                    ];
                case 'this_year':
                    return [
                        DateTime.now().startOf('year'),
                        DateTime.now(),
                    ];
                case 'last_year':
                    return [
                        DateTime.now().startOf('year').minus({ year: 1 }),
                        DateTime.now().startOf('year').minus({ days: 1 }),
                    ];
            }
        })();

        if (dates) {
            filters.value[field] = dates;
        } else {
            delete filters.value[field];
        }
    }

    async function updatePage(page: number) {
        pagesCurrent.value = page;

        await getResults();
    }

    watch(filtersPartner, async () => {
        selectedWorksheets.value = [];
        pagesCurrent.value = 1;

        if (filtersPartner.value) {
            await getResults();
        } else {
            tableData.value.items = [];
        }
    });
</script>

